export default __webpack_public_path__ + "static/icon-26-5-a5717beca9b71ad803b400a286684a9c.png";